import { useEffect, useMemo } from 'react';
import { createEventBus } from '../../../emitter';
import type { InterfaceEventBusType } from '../../types/eventBus';
import { ComputeContextKeys } from '../../hooks/computeContext/const';

/**
 * Because walkthrough is out of the InterfaceResourceProvider scope, to tell the blocks to rerender, we need to notify change of walkthrough dependency manually.
 * This hook listens to the walkthrough change event and notifies the blocks to rerender.
 */
export function useWalkthroughChangeNotification(
  interfaceId: string,
  activeInterfacePageId: string,
  subscriptionManager: {
    notifyChange: (params: { id: string }) => void;
  },
) {
  const interfaceEventBus = useMemo(
    () => createEventBus<InterfaceEventBusType>(interfaceId),
    [interfaceId],
  );

  useEffect(() => {
    const unsubscribeWalkthroughChange = interfaceEventBus.subscribe(
      'notifyWalkthroughChange',
      (params) => {
        const { pageId } = params ?? {};
        if (pageId === activeInterfacePageId) {
          subscriptionManager.notifyChange({
            id: ComputeContextKeys.WALKTHROUGH,
          });
        }
      },
    );

    return () => {
      unsubscribeWalkthroughChange();
    };
  }, [activeInterfacePageId, interfaceEventBus, subscriptionManager]);
}
